import { StyleSheet } from '@react-pdf/renderer';
import { colors } from '../../theme/colors';

export const styles = StyleSheet.create({
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingTop: 15,
    flexDirection: 'row',
  },

  text: {
    fontWeight: 400,
    fontSize: 11,
    lineHeight: '1.3px',
    color: colors.neutral700,
  },

  total: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    alignItems: 'flex-end',
    textAlign: 'right',
  },

  partialTag: {
    width: '100px',
    height: '20px',
    backgroundColor: colors.warning,
    borderRadius: '3px',
    marginLeft: 'auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    right: -5,
    bottom: -10,
  },

  partialInvoiceText: {
    fontSize: 12,
    color: colors.white,
    fontWeight: 400,
  },
});
